export default __webpack_public_path__ + "static/media/complementary--trailers--g4.b351db3d.png";